<script lang="ts">
import ModuleProjet from '@/generated/modules/ModuleProjet.vue';
import { defineComponent } from "vue";
import {ListFilter} from "@/extend/classes/ListData.ts";
import {
  storeActivite,
  storeAdresse,
  storeChat,
  storeCivilite,
  storeContrat,
  storeCreneau,
  storeDocument,
  storeEtablissement,
  storeLieu,
  storeMetaAttrib,
  storeNotif, storeNumeroObjet, storePaie,
  storeProjet,
  storeQualite,
  storeRubrique,
  storeSalarie
} from "@/generated/stores";

export default defineComponent({
  components: {},
  extends: ModuleProjet,

  computed: {
    storesLoaded (): boolean {
      return storeEtablissement.etablissementLoaded;
    }
  },

  methods: {
    loadStores(): void {
      const allData = new ListFilter();
      allData.pageLimit = -1;
      // Load and register events on used server classes
      storeActivite.registerActivite();
      storeAdresse.registerAdresse();
      storeChat.registerChat();
      storeCivilite.registerCivilite();
      storeContrat.registerContrat();
      storeCreneau.registerCreneau();
      storeDocument.registerDocument();
      storeEtablissement.registerEtablissement(allData);
      storeLieu.registerLieu();
      storeMetaAttrib.registerMetaAttrib();
      storeNotif.registerNotif();
      storeNumeroObjet.registerNumeroObjet();
      storePaie.registerPaie(allData);
      storeProjet.registerProjet();
      storeQualite.registerQualite();
      storeRubrique.registerRubrique();
      storeSalarie.registerSalarie();
    },
  }
})

</script>
